import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { CasinoSliderButtons } from '@swf/casino';
import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import Slider from '@swf/components/Slider/Slider';
import useEmbeddedAPI from '@swf/core/hooks/useEmbeddedAPI';
import { select } from '@swf/core/store';
import type { SpinOfDayData } from '@swf/core/types/CasinoBonus';
import { BonusStatus } from '@swf/core/types/CasinoBonus';
import { Category } from '@swf/core/types/StarsCoinReward';
import { sortSOTDData } from '@swf/core/utils/casino';

import Container from '../Container/Container';
import type WithClose from '../WithClose';

import styles from './SpinOfTheDay.scss';
import Ticket from './components/Ticket/Ticket';

export type SotDGameDesc = Record<string, SpinOfDayData>;
interface Props extends WithClose {
  data?: SotDGameDesc;
}

const SpinOfTheDay: React.FC<Props> = ({ data, close }) => {
  const sliderRef = React.createRef<SliderHandles>();
  const [sliderState, setSliderState] = useState<SliderState>({ left: false, right: false });
  const innerRef = useRef<HTMLDivElement>(null);
  const isMobile = useSelector(select.device.isMobile);
  const games: SpinOfDayData[] = data
    ? Object.values(data)
        .filter((bonus) => bonus.status !== BonusStatus.Paused)
        .sort(sortSOTDData)
    : [];

  useEmbeddedAPI();
  const layout = games.length < 3 ? games.length : 3;

  return games.length > 0 ? (
    <Container
      category={Category.SpinOfDay}
      right={!isMobile && <CasinoSliderButtons sliderRef={sliderRef} sliderState={sliderState} />}
      close={isMobile ? close : <div />}
    >
      <div className={styles.cardContainer}>
        <Slider
          innerClassName={styles.innerSlider}
          ref={sliderRef}
          onScroll={setSliderState}
          innerRef={innerRef}
        >
          {games.map((ticket, index) => (
            <Ticket firstGameInWidget={games[0]} key={index} data={ticket} layout={layout} />
          ))}
        </Slider>
      </div>
    </Container>
  ) : null;
};

export default SpinOfTheDay;
